module.exports = __webpack_public_path__ + "img/icon_pencil.953ff50e.svg";